import React, { useState, useEffect } from "react";
import { InputText } from "primereact/inputtext";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Button } from "primereact/button";
import { useHistory } from "react-router-dom";
import LogoDark from "../../assets/imgs/logo2.png";
import LogoLight from "../../assets/imgs/logo_light.svg";
import "./auth.css";
import { useDispatch } from "react-redux";
import { loginAction } from "../../redux/actions/authAction";
import GoogleImage from "../../assets/imgs/google.png";

const getLaptopId = async () => {
    // Placeholder function to get the laptop ID
    return "your-laptop-id"; // Replace with actual logic to get the laptop ID
};

const Login = () => {
    const [saveBtnLoading, setSaveBtnLoading] = useState(false);
    const [laptopId, setLaptopId] = useState(""); // New state for laptop ID
    const history = useHistory();
    const dispatch = useDispatch();

    useEffect(() => {
        // Assuming you have a function to get the laptop ID
        const fetchLaptopId = async () => {
            const id = await getLaptopId(); // Replace with actual function to get laptop ID
            setLaptopId(id);
        };
        fetchLaptopId();
    }, []);

    const validationSchema = Yup.object().shape({
        mobile: Yup.mixed().required("This field is required."),
        password: Yup.mixed().required("This field is required."),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            mobile: "",
            password: "",
        },

        onSubmit: async (data) => {
            setSaveBtnLoading(true);
            const payload = { ...data, device: "WebApp" }; // Include laptop ID and signupDevice in the payload

            try {
                const response = await dispatch(loginAction(payload));
                if (response?.accessToken) {
                    localStorage.setItem("refreshToken", response.refreshToken); // Save refreshToken to local storage
                    history.push("/");
                    console.log(response, "response");
                }
                setSaveBtnLoading(false);
            } catch (error) {
                console.log(error);
            }
        },
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            <form onSubmit={formik.handleSubmit}>
                <div className="flex login-main-body align-items-center justify-content-center  overflow-hidden h-screen">
                    <div className="login-div-border flex ">
                        <div className="w-full surface-card py-5 px-5 sm:px-6">
                            <div className="text-center mb-5">
                                <img src={true ? LogoLight : LogoDark} alt="Image" height="80" className=" w-18rem mb-4" />
                                <div className="text-3xl font-medium mb-3" style={{ color: "whitesmoke" }}>
                                    Welcome to Rahper
                                </div>
                                <span className="font-medium">Sign in to continue</span>
                            </div>

                            <div className="login-div ">
                                <div className="col-12">
                                    <div className="mb-4">
                                        <InputText id="mobile" type="tel" name="mobile" placeholder="Enter Phone No." value={formik.values.mobile} onChange={formik.handleChange} className="w-full  p-3" />
                                        {getFormErrorMessage("mobile")}
                                    </div>
                                    <div className="mb-3">
                                        <InputText id="password" type="password" name="password" placeholder="Enter Password" value={formik.values.password} onChange={formik.handleChange} className="w-full  p-3" />
                                        {getFormErrorMessage("password")}
                                    </div>
                                </div>

                                <p className="forgot-password-text  mb-1 font-medium no-underline ml-2 text-right cursor-pointer" onClick={() => history.push("/forgot-password")}>
                                    Forgot password?
                                </p>
                                <Button label="Login" loading={saveBtnLoading} type="submit" className="w-full mt-3 mb-3 p-3 text-xl" />
                                {/* <button type="button" className="flex align-items-center justify-content-center gap-3 w-full mb-3 cursor-pointer border-none google-btn">
                                    <img className="w-2rem mr-3" src={GoogleImage} />
                                    <span className="text-black-alpha-90 font-medium text-xl ">Sign in with Google</span>
                                </button> */}
                                <span className=" mt-2" style={{ color: "var(--text-color)", float: "right" }}>
                                    {" "}
                                    No account ?{" "}
                                    <span style={{ color: "white", cursor: "pointer" }} onClick={() => history.push("/register-user")}>
                                        {" "}
                                        Create an account first{" "}
                                    </span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default Login;
